import React, { Component } from 'react'
import { InputGroup, FormGroup, Checkbox, ControlLabel, FormControl, Button, Row, Col, Dropdown, MenuItem } from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faTimes, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { makeUniqueKey } from './helper'
import HoopSwitch from './ToggleSwitch'


class PlanForm extends Component {
  constructor(props) {
    super(props);
    if (props.mode === "edit") {
      var defaultPlaceholders = {
        plan_name: props.selectedItem.plan_name,
        plan_price: +props.selectedItem.plan_price,
        membership_fee: props.selectedItem.membership_fee ? props.selectedItem.membership_fee : "",
        early_bird_discount_percent: props.selectedItem.early_bird_discount_percent,
        early_bird_expiry: props.selectedItem.early_bird_days_before_start_expiry,
        promotionCodes: props.selectedItem.promotion_codes,
        instalments: props.selectedItem.instalments ? props.selectedItem.instalments : [],
        extraFees: props.selectedItem.extra_fees ? props.selectedItem.extra_fees : props.selectedItem.membership_fee ? [{"membership_fee" : props.selectedItem.membership_fee}]: [],
        checkout_price: props.selectedItem.checkout_price ? props.selectedItem.checkout_price : props.selectedItem.plan_price,
        passFee: props.selectedItem.pass_fee ? props.selectedItem.pass_fee : false
      }
    } else {
      defaultPlaceholders = {
        plan_name: "",
        plan_price: "",
        early_bird_discount_percent: 0,
        early_bird_expiry: 0,
        promotionCodes: [],
        instalments: [],
        extraFees: [],
        checkout_price: "",
        passFee: false
      }
    }
    this.state = {
      showpromotionCodes: false,
      promotionCodes: defaultPlaceholders.promotionCodes,
      mode: props.mode,
      defaultPlaceholders: defaultPlaceholders,
      addNewPromotionCodeVisible: false,
      addNewInstallmentVisible: false,
      addExtraFees: false,
      early_bird_status: defaultPlaceholders.early_bird_expiry !== 0  ? true : false,
      promotion_start_date: null,
      early_bird_discount_percent: defaultPlaceholders.early_bird_discount_percent,
      early_bird_expiry: defaultPlaceholders.early_bird_expiry,
      instalments: defaultPlaceholders.instalments,
      extraFees: defaultPlaceholders.extraFees,
      instalHint: false,
      earlyBirdHint: false,
      spinner: false,
      passFee: defaultPlaceholders.passFee ? defaultPlaceholders.passFee : false
    };
  }

  componentDidMount = () => {
    // if old plan with no checkout price and extra fees, calculate new checkout price
    const { defaultPlaceholders } = this.state
    if (defaultPlaceholders.checkout_price === defaultPlaceholders.plan_price && defaultPlaceholders.extraFees.length > 0) {
      this.changeCheckoutPrice('extra')
    }
  }
  
  clickOption = (option) => {
    const { defaultPlaceholders } = this.state
    var tempInstalments = this.state.instalments.slice()
    var planPrice = defaultPlaceholders.checkout_price
    
    if (planPrice === 0) {
      window.alert("Please enter a plan price.")
    } else {
      if (option === 'addNewInstallmentVisible' && tempInstalments.length === 0) {
        tempInstalments.push({
          instalment_number: 1,
          instalment_amount: planPrice
        })
        this.setState({ instalments: tempInstalments })
      } else if (option === 'early_bird_status') {
        this.setState({
          early_bird_discount_percent: 0,
          early_bird_expiry: 0
        })
      } else {
      }
      this.setState({ [option]: !this.state[option] })
    } 
  }

  getFormFields = () => {
    return {
      "plan_name": document.getElementById("plan_name").value,
      "plan_price": +document.getElementById("plan_price").value,
      "early_bird_discount_percent": this.state.early_bird_discount_percent,
      "early_bird_days_before_start_expiry": this.state.early_bird_expiry,
      "promotion_codes": this.state.promotionCodes,
      "instalments": this.state.instalments,
      "extra_fees": this.state.extraFees,
      // "checkout_price": +document.getElementById("checkout_price").value,
      "pass_fee": this.state.passFee
    }
  }

  handleCloseModal = () => {
    this.state.mode === "edit" ? this.props.handleCloseModalEdit() : this.props.handleCloseModalNew();
  }

  handleNewSubmit = () => {
    this.setState({ spinner: true })
    var check = this.checkFields("new");
    var formFields = this.getFormFields();
    console.log('formFields', formFields)
    if (check) {
      this.props.postMethod(formFields)
    } else {
      this.setState({ spinner: false })
    }
  }

  checkFields = (type) => {
    if(type === "new" || type === "update") {
      if (document.getElementById("plan_name").value === "") {
        alert("Please enter a plan name.");
        return false;
      } else if (document.getElementById("plan_price").value === "") {
        alert("Please enter a plan price.");
        return false;
      } else if (this.state.addNewPromotionCodeVisible) {
        alert("Please accept the discount code");
        return false;
      } else if (this.state.addNewInstallmentVisible) {
        alert("Please accept the instalment payment");
        return false;
      } else if (this.state.addExtraFees) {
        alert("Please accept the extra fee");
        return false;
      } else if (this.state.early_bird_days_before_start_expiry === "") {
        alert("Please enter the early bird duration.");
        return false;
      } else if (this.state.early_bird_discount_percent === "") {
        alert("Please enter the early bird's discount percent.");
        return false;
      } else {
        return true
      }
    }
  }


  handleUpdateSubmit = () => {
    this.setState({ spinner: true })
    var check = this.checkFields("update")
    var formFields = this.getFormFields()
    if(check){
      this.props.patchUpdateMethod(formFields, this.props.selectedItem._id)
    } else {
      this.setState({ spinner: false })
    }
  }

  handleArchiveSubmit = () => {
    if (window.confirm(`You are sure you want to archive ${document.getElementById("plan_name").value}?`)) {
    this.setState({ spinner: true })
    var formFields = { archived: true }
    this.props.patchUpdateMethod(formFields, this.props.selectedItem._id)
    }
  }

  handleStartDateChange = (start_date) => {
    this.setState({ promotion_start_date: start_date })
  }

  removeOption = (e, option) => {
    var temp = this.state[option]
    temp.splice(e.target.value, 1)
    this.setState({ [option]: temp })
    if (option === 'extraFees') {
      this.changeCheckoutPrice('extra')
    }
  }

  acceptPromotionCode = (change) => {
    var tempPromotionCode = this.state.promotionCodes;
    if (document.getElementById("new_key").value === "" || document.getElementById("new_discount_type").value === "" ||
      document.getElementById("new_discount_value").value === "" ||  document.getElementById("new_discount_start_date").value === "") {
        alert("The discount code is incomplete.")
    } else {
      tempPromotionCode.push({
        key: document.getElementById("new_key").value,
        discount_type: document.getElementById("new_discount_type").value,
        discount_value: document.getElementById("new_discount_value").value,
        start_date: document.getElementById("new_discount_start_date").value,
      });
      this.setState({ addNewPromotionCodeVisible: false, promotionCodes: tempPromotionCode });
    }
  }

  acceptInstalment = (change) => {
    var tempInstalment = this.state.instalments;
    if (document.getElementById("instalment_number").value === "" ) {
        alert("Please enter the $ of instalments")
    } else if (document.getElementById("instalment_number").value === 1) {
      alert("A 1-instalment option is provided by default.  Please make the # of instalments field greater than 1.")
    } else {
    tempInstalment.push({
      instalment_number: +document.getElementById("instalment_number").value,
      instalment_amount: +document.getElementById("instalment_amount").value,
      });
      this.setState({ addNewInstallmentVisible: false, instalments: tempInstalment });
    }
  }

  acceptExtraFee = () => {
    var tempFees = this.state.extraFees.slice()
    if (document.getElementById("fee_name").value === "" || document.getElementById("fee_amt").value === "") {
        alert("The extra fee is incomplete.")
    } else {
      var feeName = document.getElementById("fee_name").value.trim().replace(/\s+/g, '_')
      tempFees.push({
        [feeName]: +document.getElementById("fee_amt").value,
      })
      this.setState({ addExtraFees: false, extraFees: tempFees }, () => this.changeCheckoutPrice('extra'))
    }
  }

  acceptEarlyBird = () => {
    if (document.getElementById("early_bird_expiry").value === "" || document.getElementById("early_bird_discount_percent").value === "") {
        alert("The early bird discount is incomplete.  Please add values or select cancel.")
    } else {
      this.setState({ 
        early_bird_discount_percent: document.getElementById("early_bird_discount_percent").value,
        early_bird_expiry: document.getElementById("early_bird_expiry").value  
      });
    }
  }

  cancelPromotionCode = () => {
    this.setState({
      addNewPromotionCodeVisible: false,
      promotion_start_date: null
    })
  }

  handleInstalmentChange = (change) => {
    const { defaultPlaceholders, extraFees } = this.state
    var number = 0
    if (+change.target.value === 1) {
      window.alert('A 1-instalment option is provided by default.  Please make the # of instalments field greater than 1.')
      number = 0
    } else {
      number = +change.target.value
    }
    var price = defaultPlaceholders.checkout_price
    price = +(price / number).toFixed(2)
    document.getElementById('instalment_amount').value = price
  }


  renderEarlyBird = () => {
    const {early_bird_status, earlyBirdHint, early_bird_expiry, early_bird_discount_percent } = this.state
    var disable = false 
    if (early_bird_discount_percent !== 0 && early_bird_expiry !== 0 ) {
      disable = true
    } else {
      disable = false 
    }
    
    if (early_bird_status) {
      return (
        <div>
          <Row className="form-group plan-grid-5">
            <Col className="plan-grid-span-2 plan-grid-first">
                <div className="flex flex-row gap-1">
                  <div>Early Bird duration</div>
                  <a className="hint-tip" onClick={() => this.setState({ earlyBirdHint: !this.state.earlyBirdHint })}>
                    <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                    {
                      earlyBirdHint ?
                    <div className="hint-tip-text" id="name-hint">
                      <span>How many days before the program's Start Date does the Early Bird discount expire?</span>
                    </div>
                    : ''
                    }
                  </a>
                </div>
                <FormControl className="opaque-grey" name="early_bird_expiry" type="number" min="0" id="early_bird_expiry" defaultValue={early_bird_expiry} disabled={disable}/>
            </Col>
            <Col className="plan-grid-span-1">
                <ControlLabel>Discount Percent</ControlLabel>
                <FormControl className="opaque-grey" name="early_bird_discount_percent" type="number" min="0" id="early_bird_discount_percent" defaultValue={early_bird_discount_percent} disabled={disable}/>
            </Col>

              {
                early_bird_discount_percent === 0 && early_bird_expiry === 0 ?
                <div>
                <Col className="plan-grid-span-2 plan-inline-actions" style={{marginTop: "25px"}}>
                    <Button className="" onClick={this.acceptEarlyBird}>Accept</Button>
                    <Button className="cancel" onClick={() => this.clickOption('early_bird_status')}>cancel</Button>
                </Col>
                </div>
                
                :
                <Col className="plan-grid-span-2" style={{marginTop: "25px"}}>
                  <Button className="" onClick={() => this.clickOption('early_bird_status')}>Delete</Button> 
                </Col>
              }
          </Row>
        </div>
      )
    } 
  }

  renderExtraFees = () => {
    const { extraFees } = this.state
    var addControl = null
    if (this.state.addExtraFees) {
      addControl = 
      <div>
      <Row style={{marginTop: "10px"}} className="plan-grid-5">     

        <Col className="plan-grid-span-2 plan-grid-first">
          <FormGroup>
            <ControlLabel>Fee Name</ControlLabel>
            <FormControl className="opaque-grey" name="fee_name" type="text" min="0" id="fee_name"/>
          </FormGroup>
        </Col>

        <Col className="plan-grid-span-1">
          <ControlLabel>Fee Amount</ControlLabel>
          <FormControl className="opaque-grey" name="fee_amt" type="number" min="0" id="fee_amt" />
        </Col>

        <Col className="plan-grid-span-2 plan-inline-actions" style={{marginTop: "25px"}}>
            <Button onClick={this.acceptExtraFee}>Accept</Button>
            <Button className="cancel" onClick={() => this.clickOption('addExtraFees')}>cancel</Button> 
        </Col>

      </Row>  
      </div> 
    } else {
      addControl =
      <Row className="plan-grid-5">
        {
          extraFees.length > 0 ?
          <Col className="plan-grid-span-2" style={{marginTop: "25px"}}>
            <Button className="" onClick={() => this.clickOption('addExtraFees')}>Add Fee</Button>
          </Col>
          : ""
        }
      </Row>
    }      
    return (
      extraFees.length !== 0 ? (
            <div>

              <Row className="plan-grid-5">
                  <Col className="plan-grid-span-2 plan-grid-first">
                    <ControlLabel>Fee Name</ControlLabel>
                  </Col>

                  <Col className="plan-grid-span-1">
                    <ControlLabel>Fee Amount</ControlLabel>
                  </Col>
                  </Row>
                    { extraFees.map((input, index) => {
                      for (var fee in input) {
                        var name = fee.split('_').join(' ')
                        return (
                          <Row style={{marginTop: "10px"}} key={makeUniqueKey()} className="plan-grid-5">
                            <Col className="plan-grid-span-2 plan-grid-first">
                              <FormControl disabled value={name} className="opaque-grey" type="text" />
                            </Col>
                            <Col className="plan-grid-span-1">
                              <FormControl disabled value={input[fee]} className="opaque-grey" type="text" />
                            </Col>
                            <Col className="plan-grid-span-2">
                              <Button className="delete" value={index} onClick={(e) => this.removeOption(e, 'extraFees')}>Delete</Button>
                            </Col>
                          </Row>
                          )
                        }
                      })
                    }
                    {addControl}
            </div>
        ):
        addControl
     )
    } 

  renderInstallments = () => {
    const { instalments, addNewInstallmentVisible } = this.state
    var addControl = null
    if (addNewInstallmentVisible) {
      addControl = 
      <Row className="plan-grid-5">
          <Col className="plan-grid-span-2">
            <FormGroup>
              <ControlLabel># of Instalments</ControlLabel>
              <FormControl className="opaque-grey" name="instalment_number" type="number" min="0" id="instalment_number" onChange={this.handleInstalmentChange} />
            </FormGroup>
          </Col>

          <Col className="plan-grid-span-1">
            <ControlLabel>Instal. Amount</ControlLabel>
            <FormControl disabled className="opaque-grey" name="instalment_amount" type="number" min="0" id="instalment_amount" />
          </Col>

          <Col className="plan-grid-span-2 plan-inline-actions" style={{marginTop: "25px"}}>
              <Button className="" onClick={this.acceptInstalment}>Accept</Button>
              <Button className="cancel" onClick={() => this.clickOption('addNewInstallmentVisible')}>cancel</Button>
          </Col>
      </Row>
    } else {
      addControl = 
      <Row className="plan-grid-5">
        { instalments.length < 4 && instalments.length > 0 ?
          <Col className="plan-grid-span-2 plan-grid-first">
            <Button className="" onClick={() => this.clickOption('addNewInstallmentVisible')}>Add Installment</Button>
          </Col>
          :
          ""
        }
      </Row>
    }        
    return (
      instalments.length !== 0 ? (
        <div>
          <Row className="plan-grid-5">
            <Col className="plan-grid-span-2 plan-grid-first">
              <ControlLabel># of Instalments</ControlLabel>
            </Col>
            <Col className="plan-grid-span-1">
              <div className="flex flex-row gap-1">
                <div>Instal. Amount</div>
                <a className="hint-tip" onClick={() => this.setState({ instalHint: !this.state.instalHint })}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                  {
                    this.state.instalHint ?
                  <div className="hint-tip-text" id="name-hint">
                    <span>The first instalment is charged at checkout and remaining instalments are automatically charged every 30 days thereafter, until completion.</span>
                  </div>
                  : ''
                  }
                </a>
              </div>
            </Col>
          </Row>
            { instalments.map((input, index) => {
                var disable = false 
                
                if (input.instalment_number === 1 && instalments.length !== 1) {
                  disable = true
                } else if (input.instalment_number === 1 && instalments.length === 1 &&addNewInstallmentVisible === true) {
                  disable = true
                } else if (input.instalment_number === 1 && instalments.length === 1 &&addNewInstallmentVisible !== true) {
                  disable = false
                } else {
                  disable = false
                }
                return (
                  <Row key={makeUniqueKey()} className="form-group plan-grid-5">
                    <Col className="plan-grid-span-2 plan-grid-first">
                      <FormControl disabled value={input.instalment_number} className="col-sm-2 opaque-grey" type="text" />
                    </Col>
                    <Col className="plan-grid-span-1">
                      <FormControl disabled value={input.instalment_amount} className="col-sm-2 opaque-grey" type="text" />
                    </Col>
                    <Col className="plan-grid-span-2">
                      <Button className="delete" value={index} onClick={(e) => this.removeOption(e, 'instalments')} disabled={disable}>Delete</Button>
                    </Col>
                  </Row>)
            })}
            {addControl}
        </div>
      ):
      addControl
    )
  }

  renderPromotionCodes = () => {
    var addControl = null;
    if (this.state.addNewPromotionCodeVisible) {
      addControl = 
      <Row className="form-group plan-grid-5">
        <Col className="plan-grid-span-1 plan-grid-start">
          <ControlLabel>Key</ControlLabel>
          <FormControl className="opaque-grey" type="text" id="new_key" />
        </Col >
        <Col className="plan-grid-span-1">
          <ControlLabel>Discount Type</ControlLabel>
          <FormControl className="opaque-grey"  componentClass="select" id="new_discount_type" >
            <option value="percent">Percent</option>
            <option value="dollar">Dollar Amount</option>
          </FormControl>
        </Col >
        <Col className="plan-grid-span-1">
        <ControlLabel>Discount Value</ControlLabel>
          <FormControl className="opaque-grey" type="number" min="0" id="new_discount_value" />
        </Col >
        <Col className="plan-grid-span-1 form-group-options">
            <div>
              <ControlLabel>Start Date</ControlLabel>
              <DatePicker
                className="opaque-grey form-control datepicker1"
                id="new_discount_start_date"
                utcOffset={0}
                // placeholderText="Start Date"
                showYearDropdown
                selected={this.state.promotion_start_date}
                onChange={this.handleStartDateChange} />
            </div>
        </Col>    

          <Col className="plan-grid-span-1 plan-inline-actions" style={{marginTop: "25px"}}>
              <Button className="" onClick={this.acceptPromotionCode}>Accept</Button>
              <Button className="cancel" onClick={this.cancelPromotionCode}>Cancel</Button>
          </Col>    
 

      </Row>
    } else {
      addControl =
      this.state.promotionCodes.length > 0 ?
      <Row className="plan-grid-5">
        <Col className="plan-grid-span-2 plan-grid-first">
          <Button className="" onClick={() => this.clickOption('addNewPromotionCodeVisible')}>Add another discount code</Button>
        </Col>
      </Row>
      : 
      ""
    }

    return (
      this.state.promotionCodes.length !== 0 ? (
        <div>
          <Row key={makeUniqueKey()} className="plan-grid-5">
            <Col className="plan-grid-span-1 plan-grid-start">
              <ControlLabel>Key</ControlLabel>
            </Col>
            <Col className="plan-grid-span-1">
              <ControlLabel>Discount Type</ControlLabel>
            </Col>
            <Col className="plan-grid-span-1">
              <ControlLabel>Discount Value</ControlLabel>
            </Col>
            <Col className="plan-grid-span-1">
              <ControlLabel>Start Date</ControlLabel>
            </Col>
            <Col className="plan-grid-span-1">
              <ControlLabel>Action</ControlLabel>
            </Col>
          </Row>
            { this.state.promotionCodes.map((input, index) => {
              return (
                <Row key={makeUniqueKey()} className="form-group plan-grid-5">
                  <Col className="plan-grid-span-1 plan-grid-start">
                    <FormControl disabled value={input.key} className="col-sm-4 opaque-grey" type="text" />
                  </Col>
                  <Col className="plan-grid-span-1">
                    <FormControl disabled value={input.discount_type} className="col-sm-2 opaque-grey" type="text" />
                  </Col>
                  <Col className="plan-grid-span-1">
                    <FormControl disabled value={input.discount_value} className="col-sm-2 opaque-grey" type="text" />
                  </Col>
                  <Col className="plan-grid-span-1">
                    <FormControl disabled value={input.start_date?input.start_date.slice(0,10):null} className="col-sm-2 opaque-grey" type="text" />
                  </Col>
                  <Col className="plan-grid-span-1">
                    <Button className="delete" value={index} onClick={(e) => this.removeOption(e,'promotionCodes')}>Delete</Button>
                  </Col>
                </Row>)
            })}
            {addControl}
        </div>
      ):addControl
    )
  }

  updateInstalments = (checkoutTotal) => {
    var tempInstalments = this.state.instalments.slice()
    tempInstalments.forEach(instal => {
      var newAmt = checkoutTotal / instal.instalment_number
      instal.instalment_amount = newAmt % 1 === 0 ? newAmt : +(newAmt.toFixed(2))
    })
    this.setState({ instalments: tempInstalments })
  }

  changeCheckoutPrice = (feeAdded) => {
    const { defaultPlaceholders, passFee, extraFees } = this.state
    if (defaultPlaceholders.plan_price === "" || defaultPlaceholders.plan_price === 0) {
      window.alert("Please add a plan price before adding additional fees.")
    } else {
      var checkoutTotal = defaultPlaceholders.plan_price
      extraFees.forEach(fee => {
        for (var price in fee) {
          checkoutTotal += fee[price]
        }
      })
      if (feeAdded === 'extra') {
        var newPrice = passFee ? checkoutTotal * 1.02 : checkoutTotal
        defaultPlaceholders.checkout_price = newPrice % 1 === 0 ? newPrice : +(newPrice.toFixed(2))
      } else if (feeAdded === true && !passFee) {
        var newPrice = checkoutTotal * 1.02
        defaultPlaceholders.checkout_price = newPrice % 1 === 0 ? newPrice : +(newPrice.toFixed(2))
        defaultPlaceholders.passFee = feeAdded
        this.setState({passFee: feeAdded })
      } else if (feeAdded === false && passFee) {
        defaultPlaceholders.passFee = feeAdded
        var originalPrice = defaultPlaceholders.checkout_price / 1.02
        defaultPlaceholders.checkout_price = originalPrice % 1 === 0 ? originalPrice : +(originalPrice.toFixed(2))
        this.setState({passFee: feeAdded })
      } else if (!feeAdded && !passFee) {
        defaultPlaceholders.checkout_price = checkoutTotal
      } else if (!feeAdded && passFee) {
        var newPrice = checkoutTotal * 1.02
        defaultPlaceholders.checkout_price = newPrice % 1 === 0 ? newPrice : +(newPrice.toFixed(2))
      } 
      
      // if (defaultPlaceholders.plan_price === 0) {
      //   defaultPlaceholders.plan_price = 0
      //   defaultPlaceholders.checkout_price = 0
      // }
      if (this.state.instalments.length > 0) {
        this.updateInstalments(defaultPlaceholders.checkout_price)
      }
     this.setState({ defaultPlaceholders })
    } 
  }

  changePlanPrice = (e) => {
    const { defaultPlaceholders } = this.state
    const nextValue = e && e.target ? e.target.value : e
    defaultPlaceholders.plan_price = nextValue === "" || nextValue === null ? "" : +nextValue
    if (defaultPlaceholders.instalments && defaultPlaceholders.instalments.length > 0) {
      defaultPlaceholders.instalments.forEach(instalment => {
        var price = defaultPlaceholders.plan_price === "" ? "" : defaultPlaceholders.plan_price
        instalment.instalment_amount = price === "" ? "" : Math.ceil(price/instalment.instalment_number)
      })
    }
    if (this.state.addNewInstallmentVisible) {
      var instalmentNumberField = document.getElementById('instalment_number')
      var amount = defaultPlaceholders.plan_price === "" || !instalmentNumberField || instalmentNumberField.value === ""
        ? ""
        : Math.ceil(defaultPlaceholders.plan_price / instalmentNumberField.value)
      document.getElementById('instalment_amount').value = amount
    }

    this.setState({ defaultPlaceholders })
    // if (pass fee or whatever, the change checkout price)
    // this.changeCheckoutPrice()
  }

  render() {
    const { defaultPlaceholders, addNewInstallmentVisible, instalments, addNewPromotionCodeVisible, mode, extraFees, addExtraFees, spinner } = this.state
    const modalTitle = mode === 'new' ? 'Create New Plan' : 'Edit Plan'
    const modalSubtitle = defaultPlaceholders.plan_name || 'Plan details'
    const modalSummaryValue = defaultPlaceholders.plan_price === '' || defaultPlaceholders.plan_price === null || defaultPlaceholders.plan_price === undefined
      ? '-'
      : defaultPlaceholders.plan_price

    var submitButtons = [];
    // submitButtons.push(
    //   spinner ?
    //   ""
    //   :
    //   <Row className="modal-formfields" style={{display: "flex"}}>
    //   <Button className="cancel-option" onClick={this.handleCloseModal}>
    //     Cancel
    //   </Button>
    //   </Row>

   
       
    // );

    submitButtons.push(" ")
    if (mode === "edit") {
      if (spinner) {
        submitButtons.push(<div key={makeUniqueKey()} className="enrolment-loader"></div>)
      } else {
        submitButtons.push(
          <Row key="plan-edit-buttons" className="modal-btn-container">
          <Button className="button2 modalcancel" bsStyle="primary" onClick={this.handleArchiveSubmit}>
            Archive 
          </Button>
          <Button className="button2 modalbtn" bsStyle="primary" onClick= {this.handleUpdateSubmit}>
          Update
          </Button>          
            <Button className="cancel" onClick={this.handleCloseModal}>
            Cancel
          </Button>          

        </Row>)
      submitButtons.push(" ")
//       submitButtons.push(
// <Row className="modal-formfields">
//         <Col key={makeUniqueKey()} sm={3} xs={6}>
//           <Button className="button2 modalbtn" bsStyle="primary" onClick= {this.handleUpdateSubmit}>
//           Update
//           </Button>
//         </Col></Row>)
      }
    } else { // mode is new
      submitButtons.push(
        spinner ?
        <div key={makeUniqueKey()} className="enrolment-loader"></div>
        :
        <Row key="plan-new-buttons" className="modal-btn-container">
          <Button className="button2 plans-save" bsStyle="primary" onClick={this.handleNewSubmit}>
            Save Plan
          </Button>
          <Button className="cancel" onClick={this.handleCloseModal}>
            Cancel
          </Button>
        </Row>

      );
    }

    return (
      <div>
        <div className="transaction-modal-header">
          <div>
            <div className="transaction-modal-kicker">Pricing</div>
            <h3 className="transaction-modal-title">{modalTitle}</h3>
            <div className="transaction-modal-subtitle">{modalSubtitle}</div>
          </div>
          <div className="transaction-modal-summary">
            <div className="transaction-modal-summary-label">Plan Price</div>
            <div className="transaction-modal-summary-value">{modalSummaryValue}</div>
          </div>
        </div>

      <Row className="modal-planformfields">
        <Col>
              <Row className="plan-grid-5">     
                  <Col className="plan-grid-span-2 plan-grid-first">
                    <FormGroup>
                      <ControlLabel>Plan Name</ControlLabel>
                      <FormControl className="opaque-grey" name="plan_name" type="text" id="plan_name" 
                        defaultValue={defaultPlaceholders.plan_name} />
                    </FormGroup>
                  </Col>

                  <Col className="plan-grid-span-1">
                    <FormGroup>
                      <ControlLabel>Plan Price</ControlLabel>
                      <FormControl className="opaque-grey" name="plan_price" type="number" min="0" id="plan_price" onChange={(e) => this.changePlanPrice(e)} value={defaultPlaceholders.plan_price}/>
                    </FormGroup>
                  </Col>
                  <Col className="plan-grid-span-1">
                      <Dropdown dropup>
                        <Dropdown.Toggle id="dropdown-basic" className="" style={{marginTop: "25px", marginBottom: "15px"}}>
                          More pricing options
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <MenuItem className="drop-item" onClick={() => this.clickOption('addExtraFees')}>Add Additional Fee</MenuItem>
                          <MenuItem className="drop-item" onClick={() => this.clickOption('early_bird_status')}>Add Early Bird Promotion</MenuItem>
                          <MenuItem className="drop-item" onClick={() => this.clickOption('addNewPromotionCodeVisible')}>Add Discount Code</MenuItem>
                        </Dropdown.Menu>
                      </Dropdown>
                  </Col>      
              </Row>   

              <Row>
                  <Col sm={12}>                  
                  {this.renderExtraFees() }
                </Col>
              </Row>          
        
              <Row>
                <Col sm={12}>        
                  {(addNewInstallmentVisible || instalments.length !== 0) && <h3>Installment Payments</h3>}
                  {this.renderInstallments() }
                </Col>
              </Row>          

            <Row>
              <Col sm={12}>
                {this.renderEarlyBird()}
              </Col>
            </Row>

            <Row>
              <Col sm={12}>            
                {(addNewPromotionCodeVisible || defaultPlaceholders.promotionCodes.length !== 0) && <h3>Discount Code</h3>}
                {this.renderPromotionCodes()}
              </Col>
            </Row>          

            <Row className="modal-formbuttons">
              <Col sm={12}>
                {submitButtons}
              </Col>
            </Row>

          </Col> 
       </Row>
      </div>
    );
  }
}

export default PlanForm;
